
















import { Component, Vue, Prop } from "vue-property-decorator";
import Task from "../models/task";

@Component({})
export default class TaskListItem extends Vue {
  @Prop({ required: true }) task!: Task;

  get dueDateClassName() {
    if (!this.task.dueDateVariant) return "";
    return `text-${this.task.dueDateVariant}`;
  }

  toggle(done: boolean) {
    this.$emit("toggle", done);
  }
}
